import React from "react";
import BlueImage from "../../assets/images/HomePage/Slider/1296X508-slider1.jpg";
function Banner() {
  return (
    <div className="container">
      <img
        src={BlueImage}
        alt="Maged Bannar"
        className="img-fluid my-3"
        style={{ borderRadius: "10px", width: "100%" }}
      />
    </div>
  );
}

export default Banner;
